import { useTranslator } from '../Internationalization'
import { createExtensibleHook } from '../utils'
import { getRouteConfig } from './Config'
import type { AbsoluteRoutePath } from './Domain'

class RouteFormatter {
    constructor (protected readonly translator: ReturnType<typeof useTranslator>) {}

    formatTitle (routePath: AbsoluteRoutePath): string {
        const { title, isTitleSingular = false } = getRouteConfig(routePath)
        return this.translator.formatTranslation(title, { count: Number(isTitleSingular) })
    }
}

export const useRouteFormatter = createExtensibleHook(() => [useTranslator()] as const, RouteFormatter, 'useRouteFormatter')
